$(document).ready(() => {
    const $primaryNavigation = $('#primaryNavigation');
    const $siteHeader = $('#siteHeader');
    const $navbarToggle = $('#navbarToggle');
    const siteHeaderHeight = $siteHeader.outerHeight();
    const isMobile = window.innerWidth < 768; // You can adjust this breakpoint as needed

    // Function to close all dropdowns
    const closeAllDropdowns = () => {
        $('.sub-toggle, .sub-menu').removeClass('show');
        $('.sub-toggle').attr('aria-expanded', 'false');
    };

    // Function to trap focus within the dropdown (Desktop Only)
    const trapFocus = (event) => {
        if (isMobile) return; // Skip focus trapping on mobile

        const $activeDropdown = $('.sub-menu.show');
        if ($activeDropdown.length === 0) return;

        const focusableElements = $activeDropdown.find('a, button, input, [tabindex]:not([tabindex="-1"])');
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];

        if (event.key === 'Tab') {
            if (event.shiftKey) {
                // If Shift+Tab is pressed, cycle backward
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    event.preventDefault();
                }
            } else {
                // If Tab is pressed, cycle forward
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    event.preventDefault();
                }
            }
        }
    };

    // Handle click events
    $(document).on('click', (e) => {
        const $target = $(e.target);

        // Toggle dropdowns (Mobile & Desktop)
        if ($target.closest('.sub-toggle').length) {
            e.preventDefault();
            const $currentToggle = $target.closest('.sub-toggle');
            const isExpanded = $currentToggle.hasClass('show');

            closeAllDropdowns();

            if (!isExpanded) {
                $currentToggle.addClass('show');
                $currentToggle.next('.sub-menu').addClass('show');
                $currentToggle.attr('aria-expanded', 'true');
                // Focus on the first item in the dropdown to start focus trapping (Desktop Only)
                if (!isMobile) {
                    $currentToggle.next('.sub-menu').find('a, button, input').first().focus();
                }
            }

        // Toggle navigation collapse (Mobile)
        } else if ($target.closest('#navbarToggle').length) {
            e.preventDefault();
            const isExpanded = $primaryNavigation.hasClass('is-expanded');

            $primaryNavigation.toggleClass('is-expanded').css('top', siteHeaderHeight);
            $('body').toggleClass('no-scroll', !isExpanded);
            $siteHeader.toggleClass('nav-open', !isExpanded);
            $navbarToggle.toggleClass('show', !isExpanded);

            // When collapsing the navbar, also close all dropdowns
            if (isExpanded) {
                closeAllDropdowns();
            }

        // Close dropdowns when clicking outside (Mobile & Desktop)
        } else if (!$target.closest('.dropdown').length) {
            closeAllDropdowns();
        }
    });

    // Prevent dropdown from closing on non-anchor clicks within .sub-menu
    $('.sub-menu').on('click', (e) => {
        if (!$(e.target).is('a')) e.stopPropagation();
    });

    // Close dropdown on mobile "back" button click (Mobile)
    $('.sub-back').on('click', closeAllDropdowns);

    // Fixes global navigation when scrolled to top of page (Mobile & Desktop)
    var $navWrapper = $('#primaryNavigation .nav-wrapper');
    var navOffsetTop = $navWrapper.offset().top;

    $(window).on('scroll', function () {
        if ($(window).scrollTop() >= navOffsetTop) {
            $navWrapper.addClass('is-fixed');
        } else {
            $navWrapper.removeClass('is-fixed');
        }
    });

    // Close dropdowns when pressing ESC (Desktop Only)
    $(document).on('keydown', (e) => {
        if (e.key === 'Escape' && !isMobile) {
            closeAllDropdowns();
            $navbarToggle.focus();
        }
    });

    // Trap focus within the dropdown (Desktop Only)
    $(document).on('keydown', trapFocus);

});
